import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PersonId } from '@core/data-access/models/person.model';
import {
  CreateSavedTicketHoldersRequest,
  CreateSavedTicketHoldersResponse,
  GetSavedTicketHoldersResponse,
  UpdateSavedTicketHolderRequest
} from '@core/features/account/features/saved-ticket-holders/models/saved-ticket-holders-api.model';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SavedTicketHoldersApi {
  readonly #http = inject(HttpClient);

  getSavedTicketHolders$() {
    return this.#http.get<GetSavedTicketHoldersResponse>(
      `${environment.protocol}${environment.webApiUrl}/user/ticket-holders`
    );
  }

  deleteAllSavedTicketHolders$() {
    return this.#http.delete(`${environment.protocol}${environment.webApiUrl}/user/ticket-holders-all`);
  }

  createSavedTicketHolders$(
    language: string,
    buyerEmail: string,
    eventId: number,
    isSelfRegistration: boolean,
    createSavedTicketHoldersRequest: CreateSavedTicketHoldersRequest
  ) {
    let params: HttpParams = new HttpParams();
    params = params.append('language', language);
    params = params.append('buyerEmail', buyerEmail);
    params = params.append('eventId', `${eventId}`);
    params = params.append('sr', `${isSelfRegistration}`);

    return this.#http.post<CreateSavedTicketHoldersResponse>(
      `${environment.protocol}${environment.webApiUrl}/user/ticket-holders`,
      createSavedTicketHoldersRequest,
      { params }
    );
  }

  updateSavedTicketHolder$(
    language: string,
    eventId: number,
    isSelfRegistration: boolean,
    personId: PersonId,
    updateSavedTicketHolderRequest: UpdateSavedTicketHolderRequest
  ) {
    let params: HttpParams = new HttpParams();
    params = params.append('language', language);
    params = params.append('eventId', `${eventId}`);
    params = params.append('sr', `${isSelfRegistration}`);

    return this.#http.patch<UpdateSavedTicketHolderRequest>(
      `${environment.protocol}${environment.webApiUrl}/user/ticket-holder/${personId}`,
      updateSavedTicketHolderRequest,
      { params }
    );
  }

  deleteSavedTicketHolder$(personId: PersonId) {
    return this.#http.delete(`${environment.protocol}${environment.webApiUrl}/user/ticket-holder/${personId}`);
  }
}
